// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"486":"5f80acfe","659":"6c3f8d53"}[chunkId] + ".chunk.css";
};